// extracted by mini-css-extract-plugin
export default {"container":"AcknowledgedStatement_container__-ir7e","text":"AcknowledgedStatement_text__dLhAK"};